import * as React from 'react';
import {View} from 'react-native';
import {useStyles} from '../../shared/hooks/styles';
import {Usc} from '../../assets/images';
import {Props} from './model';
import Screen from '../../shared/components/screen';
import {Image} from '../../shared/components/image';
import {Text} from '../../shared/components/text';
import {CustomScrollView} from '../../shared/components/scrollView';
import {ExternalLink} from '../../shared/components/externalLink';
import {useSelector} from 'react-redux';
import {themeSelector} from '../../redux/selectors/runtime/theme';
import {VisImpStatus} from '../../shared/models/visuallyImpairedSettings';
import {images} from '../../assets/icons';
import {useTheme} from '../../shared/theme';

export default ({content}: Props) => {
  const theme = useTheme();
  const themeSettings = useSelector(themeSelector());
  const isVisImpActive = themeSettings.visuallyImpaired === VisImpStatus.Active;
  const styles = useStyles(() => ({
    sectionContainer: {
      marginTop: 32,
      paddingHorizontal: 35,
      paddingBottom: theme.screen.bottomOffset,
    },
    sectionContent: {},
    aboutText: {
      ...theme.fonts.bodySmallLight,
      marginBottom: 21,
      textAlign: 'center',
    },
    politics: {
      ...theme.fonts.action,
      textAlign: 'center',
    },
    logoWrapper: {
      alignSelf: 'center',
    },
  }));

  const logoProps = {
    height: 162,
    width: 197,
    style: {
      width: 197,
      height: 162,
    },
  };

  return (
    <Screen>
      <CustomScrollView testID='about-app-container-id' contentInsetAdjustmentBehavior='automatic'>
        <View style={styles.sectionContainer}>
          <View style={styles.sectionContent}>
            <View style={styles.logoWrapper}>
              {isVisImpActive ? (
                <images.LogoVisImp {...logoProps} color={theme.color.textColor} />
              ) : (
                <Image source={Usc as any} {...logoProps} />
              )}
            </View>
            <Text testID='about-app-text-id' style={styles.aboutText}>
              {content.aboutApplication}
            </Text>
            <ExternalLink
              testID='privacy-policy-external-id'
              style={styles.politics}
              link={content.docs.politics}
              text={'Политика конфиденциальности'}
              fileName={'eskso_privacy_policy'}
            />
          </View>
        </View>
      </CustomScrollView>
    </Screen>
  );
};
